import(/* webpackMode: "eager", webpackExports: ["AboutHero"] */ "/vercel/path0/components/sections/about/AboutHero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LedgerTick"] */ "/vercel/path0/components/ui/LedgerTick.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/Reveal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/SectionHeader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tilt"] */ "/vercel/path0/components/ui/Tilt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Ground"] */ "/vercel/path0/components/visual/scene/Ground.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/visual/scene/GroundObject.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
